<template>
  <slider-vendor />

  <the-nav />

  <div class="main-wrap">
    <div id="vendor">
      <div class="faq-fl">
        <div id="home-partners" class="providers-block">
          <a href="/vendor/greentube" class="img7"></a>
          <a href="/vendor/igrosoft" class="img1"></a>
          <a href="/vendor/netent" class="img2"></a>
          <a href="/vendor/pragmatic" class="img11"></a>
          <a href="/vendor/playngo" class="img4"></a>
          <a href="/vendor/yggdrasil" class="img3"></a>
          <a href="/vendor/microgaming" class="img6"></a>
          <a href="/vendor/belatra" class="img5"></a>
          <a href="/vendor/megajack" class="img8"></a>
          <a href="/vendor/unicum" class="img9"></a>
          <a href="/vendor/betinhell" class="img10"></a>
          <a href="/vendor/pushgaming" class="img13"></a>
        </div>
      </div>
      <site-info />
    </div>

    <bonuses-line />

    <play-line />
  </div>
</template>

<script>
import SliderVendor from '@/components/sliders/SliderVendor'
import PlayLine from '@/components/PlayLine'
import BonusesLine from '@/components/BonusesLine.vue'
import TheNav from '@/components/TheNav'
import SiteInfo from '@/components/SiteInfo'

export default {
  name: 'Vendor',
  components: { SliderVendor, PlayLine, BonusesLine, TheNav, SiteInfo },
  data() {
    return {
      show: false,
    }
  },
}
</script>

<style scoped></style>
